// import { useEffect, useState } from "react";
// import { LoadScript, PlacesService } from "@react-google-maps/api";
import "./../Style.css";
import {
  AdvancedMarker,
  APIProvider,
  Map,
  Pin,
} from "@vis.gl/react-google-maps";

export const Location = () => {
  // const [place, setPlace] = useState(null);
  // const placeId = "ChIJO5docUYFdZURISL5VLp2AHE";
  const apiKey = "AIzaSyBknPW_9UA_n0fzgOztg_VjVQ4FWMB9dJo";
  const defaultPosition = { lat: -34.94418880967868, lng: -54.9441949305104 };

  // const [placeDetails, setPlaceDetails] = useState({
  //   name: "Loading...",
  //   formatted_address: "Fetching address...",
  //   rating: "N/A",
  //   geometry: { location: defaultPosition },
  // });

  // useEffect(() => {
  //   fetch(
  //     `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=name,formatted_address,rating,geometry&key=${apiKey}`
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.result) {
  //         setPlaceDetails(data.result);
  //       }
  //     })
  //     .catch((error) => console.error("Error fetching place details:", error));
  // }, []);

  return (
    <div className="green">
      <APIProvider apiKey={apiKey}>
        <div style={{ display: "flex", height: "100vh", marginTop: 50 }}>
          {/* Map Container */}
          <div style={{ flex: 2 }}>
            <Map
              style={{ width: "100%", height: "100%" }}
              defaultCenter={defaultPosition}
              defaultZoom={15}
              mapId="1f655aa7bc80a00e"
              // mapId="demo"
            >
              <AdvancedMarker position={defaultPosition}>
                <Pin
                  background="#ff8800"
                  glyphColor="#fff"
                  borderColor="#fff"
                />
              </AdvancedMarker>
            </Map>
          </div>

          {/* <div
            style={{
              flex: 1,
              padding: "20px",
              background: "#fff",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h2>{placeDetails.name}</h2>
            <p>{placeDetails.formatted_address}</p>
            <p>⭐ Rating: {placeDetails.rating}</p>
          </div> */}
        </div>
      </APIProvider>
    </div>
  );
};
